export default __webpack_public_path__ + "assets/af8f8b8de3c2c64dd9e0e26f9e326c76.svg";